module.exports = __webpack_public_path__ + "img/HYU-logo.b782c071.svg";